export default {
  name: 'ProductPurchasedPerMonthBanner',
  props: {
    count: Number,
  },
  computed: {
    message() {
      return this.$t('ProductPurchasedPerMonthBanner.message', [this.count])
    },
  },
}
